module.exports = __webpack_public_path__ + "img/emptyprivilage.02f0e25e.svg";